import { useDeactivateCampaignMutation } from 'modules/campaigns/lib';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { useCancelCampaignAlerts } from '../../hooks/useCancelCampaignAlerts';
import { maybeRestErrorMessage } from '../../utils';
import { getDeactivateCampaignPayload } from './DeactivateCampaignModal.utils';

export const useDeactivateCampaign = () => {
  const { closeModal } = useModalContext();
  const { isLoading, mutate, error } = useDeactivateCampaignMutation();
  const { cancelCampaignAlerts } = useCancelCampaignAlerts();

  const dispatch = useDispatch();

  const { campaign, refetch: refetchCampaign } = useCampaignContext();
  const { campaignAlertsEnabled, id, name } = campaign;

  const deactivateCampaign = () => {
    const onSuccess = () => {
      cancelCampaignAlerts({
        campaignIds: [id],
        campaignAlertsEnabled,
      });

      dispatch(addPositiveToast(`${name} deactivated successfully.`));
      closeModal(ModalType.DeactivateCampaignModal);
      refetchCampaign();
    };

    const onError = (e: unknown) => {
      const errorResponseMessage = maybeRestErrorMessage(e);
      const defaultErrorMessage = 'Error deactivating campaign: something went wrong.';
      const errorMessage = errorResponseMessage || defaultErrorMessage;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'deactivateCampaign', e));
    };

    const payload = getDeactivateCampaignPayload(campaign);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, deactivateCampaign };
};
